import { Divider, Stack } from '@mui/material';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import { AccordionSection } from './AccordionSection';
import { ToggleSwitch } from './ToggleSwitch';
import { useFlightsFilters } from 'legacyfrontend/contexts/FlightsFiltersContext';
import { useCallback } from 'react';

const scaleOptions = [
  { id: 'oneStop', label: '1 Escala', value: '1 Escala' },
  { id: 'multiStop', label: '2 o más escalas', value: '2 o más escalas' },
];

export const FlightsFilterByScale = ({
  dropdownState,
  toggleDropdown,
  handleDirectChange,
  handleScaleChange,
  background,
}) => {
  const { handleFilters, filters } = useFlightsFilters();

  const handleAllScalesChange = useCallback(() => {
    if (filters.direct) {
      handleFilters('direct', false);
    }

    const newScale =
      filters.scales === 'Todas las escalas' ? 'Todas las escalas' : 'Todas las escalas';

    handleFilters('scales', newScale);
  }, [filters.direct, filters.scales]);

  const handleScaleOption = useCallback(
    (value) => {
      if (filters.direct) {
        handleFilters('direct', false);
      }
      handleScaleChange(value);
    },
    [filters.direct, handleScaleChange]
  );

  return (
    <Stack gap={2}>
      <AccordionSection
        isOpen={dropdownState.flights}
        onToggle={() => toggleDropdown('flights')}
        title='Vuelos'
      >
        <Stack spacing={2}>
          <ToggleSwitch
            background={background}
            icon={AirplaneTicketIcon}
            isActive={filters.scales === 'Todas las escalas' && !filters.direct}
            label='Todas'
            onChange={handleAllScalesChange}
          />

          <ToggleSwitch
            background={background}
            icon={LocalAirportIcon}
            isActive={filters.direct}
            label='Vuelo directo'
            onChange={handleDirectChange}
          />

          {scaleOptions.map((option) => (
            <ToggleSwitch
              background={background}
              icon={ConnectingAirportsIcon}
              isActive={filters.scales === option.value}
              key={option.id}
              label={option.label}
              onChange={() => handleScaleOption(option.value)}
            />
          ))}
        </Stack>
      </AccordionSection>
      <Divider />
    </Stack>
  );
};
